import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M15 16l4 -4","key":"svg-1"}],["path",{"d":"M15 8l4 4","key":"svg-2"}]]

const IconArrowNarrowRight = createReactComponent('outline', 'arrow-narrow-right', 'ArrowNarrowRight', __iconNode);

export default IconArrowNarrowRight;